// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1TAqT","boxTitle":"Qualiphy_boxTitle__2tJFJ","box":"Qualiphy_box__2T4GW","toggleWrap":"Qualiphy_toggleWrap__39275"};